export enum ResetPasswordReason {
    ForgotPassword = 0,
    ChangePasswordRequirement = 1
}
